<template>
  <section class="gallery" v-if="gallery">
    <div class="inner">
      <a :href="image.image" :key="image._id" class="popup" v-for="image in gallery">
        <img :alt="image.alt" :src="image.image">
      </a>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "Gallery",
  computed: {
    ...mapState(["gallery"])
  }
}
</script>

<style scoped>

.gallery .inner {
  margin-top:2rem;
  display:grid;
  grid-template-columns:1fr 1fr 1fr 1fr;
  grid-gap:2rem;
}

.gallery a {
  transition: all .2s;
}

.gallery a:hover {
  transform: scale(1.05);
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {  
  .gallery a {
    display:block;
    width:23%;
    padding-right:2%;
    float:left;
  }
}

</style>
